<template>
    <div class="login-model-pop-up-sec forgot-main" @click="closeCountryCodeOnOutsideClick">
        <div class="modal fade" id="forget-password-btn" tabindex="-1" aria-labelledby="exampleModalLabel"
            aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <button @click="refreshData()" ref="close_btn" type="button" class="btn-close" data-bs-dismiss="modal"
                        aria-label="Close">&#10006;</button>
                    <div class="modal-body">
                        <div class="login-body-sec">
                            <div class="login-body-lft">
                                <div class="forget-login">
                                    <div class="login-now">
                                        <div class="login-flow-heading">
                                            <div class="web-logo">
                                                <img :src="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path.domain_image + $siteSettings?.data?.logo" alt="logo">
                                            </div>
                                        </div>  
                                        <div method="post" id="register_form">
                                            <input type="hidden" name="_token" id="csrf-token">
                                            <div class="number-var mak-gin sign-up-body">
                                                <div class="input-wrap sign-up-row">
                                                    <div class="contact-info-wrapper">
                                                        <div class="country-code-flag-top-wrapper" >
                                                            <div v-if="countryCodeList && countryCodeList[contIndex]" class="country-code-flag-top-sec" @click="openCountryCode()" :class="{ 'disabled': timerRunning }">
                                                                <img loading="lazy" :src="countryCodeList[contIndex]?.flag"> <span>+{{ countryCodeList[contIndex]?.phonecode }}</span>
                                                                <i class="fa-solid fa-caret-down"></i>
                                                            </div>
                                                            <ul class="country-code-flag-sec " :class="checkCountryCodeSelect ? 'show-country-code' :''">
                                                                <template v-for="(allowedCountry, countryIndex) in countryCodeList" >
                                                                    <li v-if="allowedCountry?.phonecode != countryCodeList[contIndex]?.phonecode" 
                                                                        :key="countryIndex"  @click="selectCountryCode(countryIndex,allowedCountry?.phonecode)">
                                                                        <img loading="lazy" :src="allowedCountry?.flag"> <span>+{{ allowedCountry.phonecode }}</span>
                                                                    </li>
                                                                </template>
                                                            </ul>
                                                        </div>
                                                        <div class="input-left">
                                                            <input type="tel" maxlength="10" class="form-control" :class="init.mobile && checkValidation?.mobile?.length > 0 ? 'border border-2 border-danger': ''" 
                                                                id="phone" v-model="form.mobileNo"
                                                                :placeholder="$t('enter-mobile-number','Enter Mobile Number') +'*'" 
                                                                @input="form.mobileNo = $helper.sanitizeNumber(form.mobileNo, 9999999999);validate()" :disabled="resendOtp && timerRunning">
                                                        </div>
                                                        <button :disabled=" timerRunning" @click="optCallWithValidationCheck()" type="button" id="otp-btn"
                                                        class="thm-btn otp-btn get-otp-btn send_otp_btn" :class="{'resend__otp' : resendOtp && !timerRunning}">
                                                            <span v-if="!loadingOtp">{{ timerRunning ? formatTime(minutes) + ":" + formatTime(seconds) : resendOtp ? $t('resend-otp',"Resend OTP") : $t('get-otp',"Get OTP") }}</span>
                                                            <div v-if="loadingOtp" class="text-center" id="Otp_loader">
                                                                <div class="spinner-border" role="status">
                                                                    <span class="visually-hidden">{{$t('loading','Loading')}}...</span>
                                                                </div>
                                                            </div>
                                                        </button>
                                                    </div>
                                                    <div v-if="init.mobile && checkValidation?.mobile?.length > 0" class="">
                                                        <template v-for="(err, index) in checkValidation?.mobile" :key="index">
                                                            <p class="error-text">&#8226; {{ $t(err.lang, err.error) }}</p>
                                                        </template>
                                                    </div>
                                                    <div v-if="init.mobile && form.mobileNo.length == 10 && !isOtpApiCalled && getOTPmsg && !loadingOtp">
                                                        <p class="error-text">&#8226; {{ $t('please-click-on-send-otp','Please Click on Get OTP')}}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="mak-gin password-inpt" v-if="isOtpApiCalled">
                                                <input type="tel" class="form-control input-boxes" name="otp" :class="isOtpApiCalled && init.otp && checkValidation?.otp?.length > 0 ? 'border border-2 border-danger': ''" :placeholder="$t('enter-otp','Enter OTP') +'*'"
                                                @input="form.otp = $helper.sanitizeNumber(form.otp, 999999);validate()" required maxlength="6" id="otp-input" v-model="form.otp">
                                                <div v-if="isOtpApiCalled && init.otp && checkValidation?.otp?.length > 0">
                                                    <template v-for="(err, index) in checkValidation?.otp" :key="index">
                                                        <p class="error-text">&#8226; {{ $t(err.lang, err.error) }}</p>
                                                    </template>
                                                </div>
                                            </div>

                                            <div class="mak-gin password-inpt">
                                                <input :type="passwordFieldType" class="form-control toggle-password" name="password" maxlength="20"
                                                    id="fpassword" :placeholder=" $t('please-enter-password','Enter Password') + '*'" v-model="form.password" @input="form.password = $helper.sanitizeDetails('password', form.password, 20);validate();"
                                                    aria-describedby="password">
                                                <div class="showHide-pass" @click="togglePasswordVisibility('passwordFieldType')">
                                                    <!-- <i class="fa-solid" :class="passwordFieldType === 'password' ? 'fa-eye-slash' : 'fa-eye'"></i> -->
                                                    <img loading="lazy" :src="passwordFieldType === 'password' ? require('@/assets/images/eye-slash.svg') : require('@/assets/images/eye.svg')" alt=""/>
                                                </div>


                                                <div v-if="isOtpApiCalled && init.password && checkValidation?.password?.length > 0">
                                                    <template v-for="(err, index) in checkValidation?.password" :key="index">
                                                        <p class="error-text">&#8226; {{ $t(err.lang, err.error) }}</p>
                                                    </template>
                                                </div>
                                            </div>
                                            <div class="mak-gin password-inpt">
                                                <input :type="confPasswordFieldType" class="form-control toggle-password" maxlength="20"
                                                    id="confirm_password" v-model="form.confirmPassword" @input="form.confirmPassword = $helper.sanitizeDetails('password', form.confirmPassword, 20);validate()"
                                                    name="confirm_password" :placeholder="$t('please-enter-confirm-password','Enter Confirm Password') + '*'"
                                                    aria-describedby="password">

                                                <div class="showHide-pass" @click="togglePasswordVisibility('confPasswordFieldType')">
                                                    <!-- <i class="fa-solid" :class="confPasswordFieldType === 'password' ? 'fa-eye-slash' : 'fa-eye'"></i> -->
                                                    <img loading="lazy" :src="confPasswordFieldType === 'password' ? require('@/assets/images/eye-slash.svg') : require('@/assets/images/eye.svg')" alt=""/>
                                                </div>

                                                <div v-if="isOtpApiCalled && init.confirmPassword && checkValidation?.confirmPassword?.length > 0">
                                                    <template v-for="(err, index) in checkValidation?.confirmPassword" :key="index">
                                                        <p class="wrong-message">&#8226; {{ $t(err.lang, err.error) }}</p>
                                                    </template>
                                                </div>
                                            </div>

                                           

                                            <input type="hidden" id="isDownLine" name="isDownLine" value="">

                                            <button @click="forgetPasswordCall()" type="submit"
                                                class="btn thm-but main-btn" id="submitBtn">
                                                <span v-if="!loadingUpdate">{{ $t('update-password','Update Password') }}</span>
                                                <div v-if="loadingUpdate" class="text-center" id="Otp_loader">
                                                    <div class="spinner-border" role="status">
                                                        <span class="visually-hidden">{{ $t('loading','Loading') }}...</span>
                                                    </div>
                                                </div>
                                            </button>


                                            <p class="forpass-in">{{ $t('remember-your-password','Remember your password')}}?<a href="#login-btn"
                                                    data-bs-toggle="modal" @click="refreshData">{{ $t('log-in','Login')}}</a></p>
                                            <div class="create-new-acc">
                                                <a href="#register-btn" data-bs-toggle="modal" @click="refreshData">{{ $t('create-new-account','Create New Account')}}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="login-body-rgt">
                                <div class="banner-side-img-sec">
                                    <div class="slider-model-pic">
                                        <div class="slider-model-pic">
                                            <img loading="lazy" src="@/assets/images/sl-lc-one-layer-two.webp" alt="sl-lc-one-layer-two" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import commonAuth from '../services/commonAuth';
import validate from '../services/authValidation';
export default {
    name: "ForgetPassword",
    extends: commonAuth,
    data() {
        return {
            form: {
                code: this.$store.getters?.siteSettings?.country_code ? this.$store?.getters?.siteSettings.country_code : 91,
                mobileNo: "",
                otp: '',
                password: "",
                confirmPassword: "",
            },
            loadingUpdate: false,
            checkCountryCodeSelect:false,
            defaultCountryCode : this.$store?.getters?.siteSettings?.country_code,
            init:{
                mobile:false,
                otp:false,
                confirmPassword:false,
                password:false
            },
            validationErrors : null,
            contIndex:0,
        };
    },
    computed: {
        countryCodeList(){
            return this.$store?.getters?.siteSettings?.country_code_list;
        },
        checkValidation() {
			return this.validationErrors;
		}
    },
    mounted(){
        this.contIndex =  this.countryCodeList?.findIndex(ci => ci.phonecode == this.defaultCountryCode)
        if(this.$route.name == 'forget-password' && !this.$auth?.status){
            setTimeout(()=> {
                this.$helper.openModal('#forget-password-btn')
            }, 500)
            this.$router.push({name: 'Home'});
        }
        else if(this.$route.name == 'forget-password' && this.$auth?.status){
            this.$router.push('/')
        }
    },
    methods: {
        closeCountryCodeOnOutsideClick(event) {
            const countryCodeElement = this.$el.querySelector('.country-code-flag-top-wrapper');
            if (countryCodeElement && event && event.target && !countryCodeElement.contains(event.target)) {
                this.checkCountryCodeSelect = false;
            }
        },
       selectCountryCode(code,phone_code){
            this.contIndex = code;
            this.form.code = parseInt(phone_code)
            this.checkCountryCodeSelect = !this.checkCountryCodeSelect
        },
        openCountryCode(){
            this.checkCountryCodeSelect = !this.checkCountryCodeSelect
        },
        forgetPasswordCall() {
            if (this.loadingUpdate) return;
            this.toggleInitPhn(true);
            this.getOTPmsg = true;
            if(this.isOtpApiCalled) {
                this.toggleOTPInit(true);
            }
            if(this.getOtp()?.length){
                this.toggleInit(true)
            }
            if(Object.keys(this.validate()).length != 0) return;
            if (!this.isOtpApiCalled){ 
                return
            }
            this.forgotServiceCall();
        },
        forgotServiceCall() {
            this.loadingUpdate = true;
            this.$store.dispatch('setGlobalLoader', true);            
            let data = {
                "phone": this.form.mobileNo,
                "cncode": this.form.code,
                "password": this.form.password,
                "confirm_password": this.form.confirmPassword,
                "otp": this.form.otp,
            };
            this.$apiCall('post','FORGOT_PASSWORD', data).then(response => {
                this.$store.dispatch('setGlobalLoader', false);
                this.loadingUpdate = false;
                if (response) {
                    if (response.status == 200) {
                        if (response.data.status == 0) {
                            this.$errorToast(response.data.debug[0]);
                        }
                        else {
                            this.$successToast(response.data.message);
                            this.refreshData();
                            this.$helper.closeModal('forget-password-btn');
                            setTimeout(() => {
                                this.$helper.openModal('#login-btn')
                            }, 500);
                        }
                    }
                }
            }).catch(error => {
                this.$store.dispatch('setGlobalLoader', false);
                this.loadingUpdate = false;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        validate(){
            this.validationErrors = validate.areFieldsValid(
                'forgot-password',
				this.form.mobileNo, 
				this.form.otp, 
				this.form.password,
				this.form.confirmPassword,
            );
            return this.validationErrors;                                                                                                    
        },
        validateMobileOnly(){
            this.validationErrors = validate.areFieldsValid(
                'only-mobile',
				this.form.mobileNo
            );
            return this.validationErrors;
        },
        toggleInitPhn(bool){
            this.init={
                mobile:bool
            }
        },
        toggleInit(bool){
            this.init={
                mobile:bool,
                otp:bool,
                confirmPassword:bool,
                password:bool
            }
        },
        toggleOTPInit(bool){
            this.init={
                otp:bool
            }
        },
        optCallWithValidationCheck(){
            this.getOTPmsg = true;
            this.toggleInitPhn(true);
            this.validate();
            this.sendOtpCall();
        },

    }
};
</script>